const L10N = {
  ACTION_PAY: { id: 'core.action.pay' },

  LABEL_ADDRESS: { id: 'core.label.address', defaultMessage: 'Address' },
  LABEL_CITY: { id: 'core.label.city', defaultMessage: 'City' },
  LABEL_STATE: { id: 'core.label.state', defaultMessage: 'State' },
  LABEL_COUNTRY: { id: 'core.label.country', defaultMessage: 'Country' },
  LABEL_ZIP: { id: 'core.label.zip', defaultMessage: 'Zip Code' },

  NOTIFICATION_ERROR: { id: 'common.notification.error_unknown' },
};

export { L10N };
